import { Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { AdminMenuLayout } from "../../../shared/components";
import { selectCampaignForUpdate } from "../../../redux";
import { useCampaigns, useCampaignsById } from "../hooks";
import { CampaignsForm, CampaignsProductsPanel } from "./campaignById";
import { WrapperCardCampaigns, WrapperTabNavCampaigns } from "./styled";

const { Paragraph } = Typography;

export const CampaignsById = () => {
  const { isUpdateCampaign, formMethodsCreate, formMethodsUpdate } =
    useCampaigns();
  const { isValidate } = useCampaignsById();
  const campaign = useSelector(selectCampaignForUpdate);
  const location = useLocation();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("1");
  const canManageProducts =
    isUpdateCampaign &&
    id != null &&
    id !== "new" &&
    !Number.isNaN(Number(id)) &&
    campaign?.products_mode === "manual";

  useEffect(() => {
    const tab = (location.state as { campaignTab?: string } | null)?.campaignTab;
    if (tab && canManageProducts) setActiveTab(tab);
  }, [location.state, location.pathname, canManageProducts]);

  useEffect(() => {
    if (!canManageProducts) setActiveTab("1");
  }, [canManageProducts]);

  return (
    <AdminMenuLayout pageDescription="CampañasById" title="CampañasById">
      <WrapperCardCampaigns>
        {!isValidate ? (
          <Spin size="large" />
        ) : (
          <WrapperTabNavCampaigns
            activeKey={activeTab}
            onChange={setActiveTab}
            items={[
              {
                label: `DATOS DE LA CAMPAÑA`,
                key: "1",
                children: (
                  <FormProvider
                    {...(isUpdateCampaign
                      ? formMethodsUpdate
                      : formMethodsCreate)}
                  >
                    <CampaignsForm />
                  </FormProvider>
                ),
              },
              {
                label: `PRODUCTOS`,
                key: "2",
                children: canManageProducts ? (
                  <CampaignsProductsPanel />
                ) : (
                  <div style={{ padding: 24 }}>
                    <Paragraph>
                      El modo de productos debe ser <strong>Manual</strong> y la
                      campaña debe estar guardada para asociar productos del
                      catálogo.
                    </Paragraph>
                  </div>
                ),
              },
            ]}
          />
        )}
      </WrapperCardCampaigns>
    </AdminMenuLayout>
  );
};
